import type { FC, ReactNode } from "react";
import classNames from "classnames";

export const MaxRootWidthWrapper: FC<{
  children: ReactNode | Array<ReactNode>;
  className?: string;
}> = ({ children, className }) => {
  return (
    <div className={classNames("max-root-width", className)}>{children}</div>
  );
};
